import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { QuestionInputTypes } from '../form';
export var RedeemRewardError = t.intersection([t.type({
  message: t.string
}), t.partial({
  extensions: nullable(t.type({
    fullMessages: t.array(t.string)
  }))
})]);
// Picks the first server-side validation message (e.g. "Address is too long
// (maximum is 35 characters)") from a RedeemRewardErrors payload, if any error
// carries one via extensions.fullMessages. Returns undefined when none do, in
// which case the caller falls back to the generic failure alert. Kept as a
// pure, exported function so it can be unit-tested independently of the hook.
export var firstRedeemValidationMessage = function firstRedeemValidationMessage(errors) {
  return errors.flatMap(function (error) {
    var _error$extensions$ful, _error$extensions;

    return (_error$extensions$ful = (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.fullMessages) !== null && _error$extensions$ful !== void 0 ? _error$extensions$ful : [];
  }).find(function (message) {
    return message !== '';
  });
};
export var RedeemRewardOutput = t.type({
  redeemReward: t.union([t.type({
    __typename: t.literal('RedeemRewardErrors'),
    errors: t.array(RedeemRewardError)
  }), t.type({
    __typename: t.literal('RedeemRewardResult'),
    message: nullable(t.string)
  })])
});
export var ShippingAddressInput = t.intersection([t.type({
  phoneNumber: t.string,
  fullName: t.string,
  address: t.string,
  city: t.string,
  country: t.string,
  postalCode: t.string
}), t.partial({
  address2: nullable(t.string),
  region: nullable(t.string)
})]);
export var RewardInput = t.intersection([t.type({
  id: t.string
}), t.partial({
  responses: t.array(QuestionInputTypes.Response),
  shippingAddress: ShippingAddressInput
})]);
export var RedeemRewardInput = t.type({
  input: RewardInput
});
export var EditShippingAddressResult = t.type({
  __typename: t.literal('EditShippingAddressResult'),
  address: t.type({
    address: t.string
  })
});
export var ShippingAddressOutput = t.type({
  editShippingAddress: t.union([t.type({
    __typename: t.literal('EditShippingAddressErrors'),
    errors: t.array(t.type({
      message: t.string
    }))
  }), EditShippingAddressResult])
});
export var EditShippingAddressInput = t.type({
  input: ShippingAddressInput
});